// client/src/components/layout/Layout.js
import React, { useState, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = ({ title }) => {
  const sidebarRef = useRef(null);
  
  // Funzione per gestire il toggle della sidebar
  const handleToggleSidebar = () => {
    // Trova il componente Sidebar e chiama la sua funzione toggleSidebar
    if (sidebarRef.current && sidebarRef.current.toggleSidebar) {
      sidebarRef.current.toggleSidebar();
    } else {
      // Fallback: cerca e clicca il pulsante sidebar-toggle esistente
      const existingToggle = document.querySelector('.sidebar-toggle');
      if (existingToggle) {
        existingToggle.click();
      } else {
        // Fallback finale: gestione manuale delle classi
        const sidebar = document.querySelector('.sidebar');
        const body = document.body;
        if (sidebar) {
          sidebar.classList.toggle('expanded');
          body.classList.toggle('sidebar-open');
        }
      }
    }
  };
  
  return (
    <div className="layout">
      <Sidebar ref={sidebarRef} />
      <div className="main-content">
        <Header title={title} onToggleSidebar={handleToggleSidebar} />
        <div className="content-area">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;